import { render, staticRenderFns } from "./SwabSampleAnalysisTable.vue?vue&type=template&id=5d170d50&scoped=true&"
import script from "./SwabSampleAnalysisTable.vue?vue&type=script&lang=ts&"
export * from "./SwabSampleAnalysisTable.vue?vue&type=script&lang=ts&"
import style0 from "./SwabSampleAnalysisTable.vue?vue&type=style&index=0&id=5d170d50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d170d50",
  null
  
)

export default component.exports